import { 
  SET_NUMBER_OF_UNFILLED_ORDERS
} from '../types/orders';

export function setNumberOfUnfilledOrders(numberOfUnfilledOrders) {
  return { type: SET_NUMBER_OF_UNFILLED_ORDERS, numberOfUnfilledOrders };
}